import { cn } from "@/lib";
import React, { ComponentProps } from "react";
import { FlexBetween } from "./ui";

interface IToggleCardProps extends ComponentProps<"div"> {
  isSelected: boolean;
  setSelected: () => void;
  nodeStart?: React.ReactNode;
  nodeEnd?: React.ReactNode;
  clickable?: boolean;
  childClassName?: string;
  id?: string;
  disable?: boolean;
}

const ToggleCard: React.FC<IToggleCardProps> = ({
  isSelected,
  setSelected,
  children,
  nodeStart,
  nodeEnd,
  clickable = true,
  className,
  childClassName,
  disable = false,
  id = "toggle-btn",
}) => {
  return (
    <FlexBetween
      id={id}
      gap={4}
      onClick={() => {
        if (!clickable) {
          return;
        }
        setSelected();
      }}
      className={cn(
        "shadow-main rounded-xl border border-transparent p-2 text-sm xl:p-4 xl:text-base",
        isSelected && "border-primary-main shadow-primary-main",
        clickable && !disable && "cursor-pointer",
        className,
        disable && "cursor-not-allowed text-gray-400",
      )}
    >
      <div className={cn("flex grow gap-2", childClassName)}>
        {nodeStart && <div className={cn("")}>{nodeStart}</div>}
        {children}
      </div>
      {nodeEnd && !disable && <div className={cn("")}>{nodeEnd}</div>}
    </FlexBetween>
  );
};

export default ToggleCard;
